<style lang="scss">
@import '~normalize.css';
@import '~bootstrap/dist/css/bootstrap.css';
@import '~bootstrap-vue/dist/bootstrap-vue.css';
@import '~animate.css';

.fade-enter-active  { animation: fadeIn 1s }
.fade-leave-active  { animation: fadeOut 1s }

html, body, #appContent{
  height: 100%;
}
#app {
  height: 100%;
  width: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
#message_center {
  width: 30%;
  position: absolute;
  top: 0;
  right: 0;
}
</style>

<template>
  <div id="app">
    <div id="message_center" class="mr-2 mt-2">
      <Messenger
        v-for="(msgObj, index) in globalMessages"
        :key="index"
        :index="index"
        :msg="msgObj"
      />
    </div>
    <transition
      appear
      appear-active-class="fade-enter-active"
      leave-active-class="fade-leave-active"
    >
      <Loading v-if="['AUTH_STATE_AUTHING', null].includes(authState)"/>
      <div id="appContent" v-else>
        <Navbar v-if="!(identificationRoutes.includes($route.path))"/>
        <transition name="slide">
          <router-view/>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex'
import { identificationRoutes } from '@/router'
import Loading from '@/components/Loading.vue'
import Messenger from '@/components/Messenger.vue'
import Navbar from '@/components/Navbar.vue'

export default {
  name: 'home',
  components: {
    Loading,
    Messenger,
    Navbar
  },
  data () {
    return {
      identificationRoutes
    }
  },
  computed: mapState([
    'authState',
    'globalMessages'
  ])
}
</script>



// WEBPACK FOOTER //
// src/App.vue